import { Component } from "@angular/core";
import { Names } from "../names";
import { ApplicationBarLayoutComponent } from "../ApplicationBar/ApplicationBarLayoutComponent";
// import { FiltersLayout } from "../Filter/FilterLayoutComponent";

// Providers
import { GlobalService } from "@nordpoolgroup/nps-angular-2-common";
import { MessagesService } from "@nordpoolgroup/nps-angular-2-common";

@Component({
    selector: Names.mainView.selector,
    template: require("./mainViewComponent.html")
})

export class MainViewComponent {
    constructor(
        globalService: GlobalService,
        private messagesService: MessagesService) {
    }
}



// WEBPACK FOOTER //
// ./src/app/MainView/MainViewComponent.ts